import { default as DatetimePickerModule, DatetimePickerTypeEnum } from "./datetimepickerModule";

export { DatetimePickerModule, DatetimePickerTypeEnum };



// WEBPACK FOOTER //
// ./lib/ts/modules/datetimepicker/index.ts